import { uniqueId } from "lodash";

export const SIDEBAR_ITEM = "sidebarItem";
export const ROW = "row";
export const COLUMN = "column";
export const COMPONENT = "component";
export const TITLE = "title";
export const VALUE = "value";
export const TEXT = "text";

export const SIDEBAR_PID_ITEMS = [
  {
    id: uniqueId(),
    type: SIDEBAR_ITEM,
    component: {
      type: "title",
      pids: []
    }
  },
  {
    id: uniqueId(),
    type: SIDEBAR_ITEM,
    component: {
      type: "value",
      pids: []
    }
  },
];

export const SIDEBAR_GENERAL_ITEMS = [
  {
    id: uniqueId(),
    type: SIDEBAR_ITEM,
    component: {
      type: "text",
      value: "",
    }
  },
];
